import React from 'react';
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent
} from '@material-ui/core';
import { Delete } from '@jda/lui-common-icon-library';
import useStyles from './Style';
import * as _ from 'lodash';

const ruleOperators = [
  {
    label: '<',
    value: 'lessThan'
  },
  {
    label: '>',
    value: 'greaterThan'
  },
  {
    label: '<=',
    value: 'lessThanEqual'
  },
  {
    label: '>=',
    value: 'greaterThanEqual'
  },
  {
    label: '===',
    value: 'equalTo'
  },
  {
    label: '!==',
    value: 'notEqualTo'
  }
];

const concatOperators = [
  {
    label: '&&',
    value: 'logicalAnd'
  },
  {
    label: '||',
    value: 'logicalOr'
  }
];

const AddRuleDialog = (props: any) => {
  const classes = useStyles();

  const handleParameterChange = (e: any, index: number, label: string, key: any) => {
    if (
      label === 'operator' ||
      label === 'path' ||
      label === 'value' ||
      label === 'concatOperator' ||
      label === 'ruleFull'
    ) {
      props.formInfo.parameters?.map((item: any) => {
        (item?.[key] || [])?.map((op: any, ind: number) => {
          if (op.step === index) {
            if (label === 'ruleFull') {
              op[label] = op?.path + op?.operator + op?.value;
              console.log('ruleFull: ' + op?.path + op?.operator + op?.value);
            } else op[label] = e.target.value;
          }
        });
      });
    }

    props.setFormInfo({
      ...props.formInfo
    });
  };

  const handleDeleteRuleOperator = (sequence: any, step: any) => {
    _.forEach(props?.formInfo.parameters || [], (element: any) => {
      if (element.sequence === sequence) {
        element?.[sequence]?.splice(step - 1, 1);
      }
    });

    props.setFormInfo({
      ...props.formInfo
    });
  };

  const handleAddRuleOperator = () => {
    _.forEach(props.formInfo.parameters || [], (element: any) => {
      if (element.sequence === props?.sequenceNumber) {
        element?.[props?.sequenceNumber].push({
          operator: '',
          value: '',
          path: '',
          concatOperator: '',
          step: element[props?.sequenceNumber].length ? element[props?.sequenceNumber].length + 1 : 1
        });
      }
    });

    props.setFormInfo({
      ...props.formInfo
    });
  };
  return (
    <div>
      <Dialog
        key={'edit-rule-dialog'}
        open={props.edit}
        onClose={props.handleDialogClose}
        title={props.edit ? 'Edit Rule' : 'New Rule'}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogContent>
          {(props.formInfo?.parameters || []).map((paramObj: any, index: number) =>
            (paramObj?.[props?.sequenceNumber] || []).map((item: any, ind: number) => (
              <>
                <Grid container className={classes.stepList} style={{ width: '100%' }}>
                  <Grid item xs={3}>
                    <InputLabel id="ruleValue-label">Concat Operator</InputLabel>
                    <Select
                      id="Select-concat-operator"
                      data-id="Select-concat-operator"
                      name="concatOperator"
                      onChange={e => handleParameterChange(e, item.step, 'concatOperator', props?.sequenceNumber)}
                      value={item?.concatOperator || ''}
                      className={classes.select}
                      disabled={item.step === 1 ? true : false}
                    >
                      {concatOperators?.map((operator: any) => (
                        <MenuItem value={operator.label}>{operator.label}</MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={3}>
                    <InputLabel id="rulePath-label">Rule Path</InputLabel>
                    <TextField
                      data-id="rulePathName-input"
                      id="rulePathName"
                      name="path"
                      value={item?.path || ''}
                      onChange={e => handleParameterChange(e, item.step, 'path', props?.sequenceNumber)}
                      style={{ width: '80%' }}
                      //   required
                      //   disabled={edit}
                    ></TextField>
                  </Grid>
                  <Grid item xs={2}>
                    <InputLabel id="ruleOperator-label">Rule Operator</InputLabel>
                    <Select
                      id="Select-rule-operator"
                      data-id="Select-rule-operator"
                      name="operator"
                      onChange={e => handleParameterChange(e, item.step, 'operator', props?.sequenceNumber)}
                      value={item?.operator || ''}
                      className={classes.select}
                    >
                      {ruleOperators?.map((operator: any) => (
                        <MenuItem value={operator.label}>{operator.label}</MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item xs={2}>
                    <InputLabel id="ruleValue-label">Rule Value</InputLabel>
                    <TextField
                      data-id="rulePathValue-input"
                      id="rulePathValue"
                      name="value"
                      value={item?.value || ''}
                      onChange={e => handleParameterChange(e, item.step, 'value', props?.sequenceNumber)}
                      style={{ width: '60%' }}
                      //   required
                      //   disabled={edit}
                    ></TextField>
                  </Grid>

                  <Grid item xs={2}>
                    <Delete
                      data-id="delete-step"
                      onClick={() => handleDeleteRuleOperator(props?.sequenceNumber, item.step)}
                      style={{ cursor: 'pointer' }}
                    />
                  </Grid>
                </Grid>
              </>
            ))
          )}
        </DialogContent>
        <DialogActions>
          <Button data-id="add-Button" autoFocus onClick={handleAddRuleOperator} color="primary" variant="outlined">
            Add
          </Button>
          <Button
            data-id="cancel-Button"
            autoFocus
            onClick={props.handleDialogClose}
            color="primary"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            data-id="add-Button"
            autoFocus
            onClick={() => props.handleDialogSubmit(props?.sequenceNumber)}
            color="primary"
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default AddRuleDialog;
